module.exports = __webpack_public_path__ + "img/vue2-toebox_gris.d6db38ef.png";